// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container_ndxAC","FormContainer":"FormContainer_YYoid"};